export default "__VITE_ASSET__C7Q0P9kY__"